import { addTypedProvider } from '../../metaData.js';
import { mapModuleTags } from '../Tags.js';
import { dataLookup, DATA_PRIORITY, instanceLookup } from './dataLookup.js';
import { makeArrayLike } from './makeArrayLike.js';
import { metadataLog } from '../logging.js';
const log = metadataLog.getLogger('tagModules');
const mapModules = new Map();
export function clearTagModules() {
    mapModules.clear();
}
export function tagModules(module, dataLookupName = 'instance') {
    if (!mapModuleTags.has(module)) {
        throw new Error(`No module found: ${module}`);
    }
    if (mapModules.has(module)) {
        return mapModules.get(module);
    }
    if (dataLookupName === 'instance') {
        addTypedProvider(module, instanceLookup, { priority: 25_000 });
    }
    else if (dataLookupName) {
        addTypedProvider(module, dataLookup(dataLookupName), { priority: 25_000 });
    }
    const moduleProvider = (next, query, data, options) => {
        const keys = mapModuleTags.get(module);
        const destName = options?.destName || 'lowerName';
        if (!data) {
            return next(query, data, options);
        }
        const result = {};
        for (const key of keys) {
            let value = data[key.name];
            if (value !== undefined) {
                if (mapModules.has(key.name)) {
                    log.debug('Getting nested module', key.name);
                    const newValue = [];
                    for (const entry of value) {
                        if (!entry) {
                            continue;
                        }
                        newValue.push(mapModules.get(key.name)(null, query, entry, options?.[key.name]));
                    }
                    value = newValue.length === 1 ? makeArrayLike(newValue[0]) : newValue;
                }
                result[key[destName]] = value;
            }
        }
        return result;
    };
    mapModules.set(module, moduleProvider);
    return moduleProvider;
}
export const MODULE_PRIORITY = { priority: -1_000 };
export function registerTagModules() {
    for (const module of mapModuleTags.keys()) {
        const providerFn = tagModules(module);
        if (providerFn) {
            addTypedProvider(module, providerFn, MODULE_PRIORITY);
        }
        addTypedProvider(module, instanceLookup, DATA_PRIORITY);
    }
}
